import { useState } from 'react';
import { API_URL } from '@constants';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/spaces/all-coordinates';

export interface SpaceCoordinate {
    uuid: string;
    latitude: string | null;
    longitude: string | null;
    space_type: string | null;
    space_type_uuid: string | null;
    space_type_category: string | null;
    featured_type: string | null;
    space_status: string | null;
    space_status_uuid: string | null;
}

export interface GetSpacesCoordinatesInput {
    spaceTypeUuid?: string;
    featuredType?: string;
}

export interface GetSpacesCoordinatesSuccessResponse {
    data: SpaceCoordinate[];
    success: boolean;
    message: string;
}

export const useGetSpacesCoordinates = () => {
    const { getHeaders, handleCommonErrors } = useApiConfig();
    const [coordinates, setCoordinates] = useState<SpaceCoordinate[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const request = async (props: GetSpacesCoordinatesInput = {}) => {
        setLoading(true);
        setError(null);

        const queryParams = new URLSearchParams();

        if (props.spaceTypeUuid) {
            queryParams.append('spaceTypeUuid', props.spaceTypeUuid);
        }

        if (props.featuredType) {
            queryParams.append('featuredType', props.featuredType);
        }

        try {
            const queryString = queryParams.toString();

            const response = await fetch(
                `${API_URL}${ENDPOINT_URL}${queryString ? `?${queryString}` : ''}`,
                {
                    method: 'GET',
                    headers: getHeaders(),
                }
            );

            if (!response.ok) {
                const json = await response.json();
                const error = new Error(json.error || json.message || 'Erro ao buscar coordenadas dos espaços') as ApiError;
                error.statusCode = response.status;
                throw error;
            }

            const result: GetSpacesCoordinatesSuccessResponse = await response.json();

            setCoordinates(result.data || []);
        } catch (err: any) {
            handleCommonErrors(err);
            setError(err.message || 'Erro ao buscar coordenadas dos espaços');
        } finally {
            setLoading(false);
        }
    };

    return { coordinates, request, loading, error };
};
